import { render, staticRenderFns } from "./MadalyonPage.vue?vue&type=template&id=caa51646&scoped=true&"
import script from "./MadalyonPage.vue?vue&type=script&lang=js&"
export * from "./MadalyonPage.vue?vue&type=script&lang=js&"
import style0 from "./MadalyonPage.vue?vue&type=style&index=0&id=caa51646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa51646",
  null
  
)

export default component.exports